<template>
  <button
    :class="loading ? loadingClass : defaultClass"
    :aria-label="ariaLabel"
    :data-testid="dataTestId"
    :disabled="loading"
    class="flex justify-center items-center"
    @click="handleClick"
  >
    <span
      v-if="!loading || (!loadingIconEnabled && !$slots['loading-content'])"
    >
      {{ buttonText }}
    </span>

    <span v-else class="flex justify-center items-center">
      <slot name="loading-content">
        <ProgressActivityIcon
          v-if="loadingIconEnabled"
          class="h-6 w-6 animate-spin"
        />
      </slot>
    </span>
  </button>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { ProgressActivityIcon } from "@/components/shared/icons";

const props = defineProps({
  buttonText: {
    type: String,
    required: true,
    default: "Click Me",
  },
  ariaLabel: {
    type: String,
    default: "Button",
  },
  defaultClass: {
    type: String,
    default: "bg-teal-900 text-white p-4 w-full font-semibold mb-4",
  },
  loadingClass: {
    type: String,
    default:
      "bg-teal-900 text-white p-4 w-full font-semibold mb-4 opacity-50 pointer-events-none",
  },
  onClickAction: {
    type: Function,
    required: true,
  },
  dataTestId: {
    type: String,
    required: true,
  },
  loadingIconEnabled: {
    type: Boolean,
    default: false,
  },
});

const loading = ref(false);

const handleClick = () => {
  loading.value = true;
  props.onClickAction().finally(() => {
    loading.value = false;
  });
};
</script>
